module.exports = __webpack_public_path__ + "img/2451.c01567e8.gif";